/**
 * Default Odoo JSON-RPC session (same as legacy MainService.getSession).
 * Env vars ODOO_DB, ODOO_USER, ODOO_PASSWORD override these for scripts/SSR.
 */
export const ODOO_SESSION_DEFAULTS = {
    db: "TAZEJ_FOOD",
    login: "admin",
    password: "HxW7TQCKTaUBxrL",
};
